import React, { useState, useEffect } from 'react';
import { FaRobot, FaTimes } from 'react-icons/fa';
import { useChat } from '../../../contexts/ChatContext';
import { useAuth } from '../../../contexts/AuthContext';
import './ChatButton.css';

const ChatButton = () => {
  const { isOpen, toggleChatWindow } = useChat();
  const { userRole, currentUser } = useAuth();
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  
  // Don't show chat button for admin users - check multiple conditions
  const isAdmin = userRole === 'admin' || 
                   currentUser?.role === 'admin' || 
                   currentUser?.is_staff || 
                   currentUser?.is_superuser;
  
  // Add a small delay before showing the button
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Don't show chat button for admin users - early return AFTER hooks
  if (isAdmin) {
    return null;
  }
  
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Prevent multiple rapid clicks
    if (e.detail > 1) return;
    
    toggleChatWindow();
  };
  
  if (!isVisible) return null;
  
  return (
    <div 
      className={`chat-button-container ${isOpen ? 'chat-open' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button 
        className="chat-button"
        onClick={handleClick}
        aria-label={isOpen ? 'Close chat' : 'Open chat'}
      >
        {isOpen ? (
          <FaTimes className="chat-icon" />
        ) : (
          <FaRobot className="chat-icon" />
        )}
        {isHovered && !isOpen && (
          <span className="chat-tooltip">Need help? Chat with us!</span>
        )}
      </button>
    </div>
  );
};

export default ChatButton;
